import { useMemo, useState } from 'react'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
}

const INITIAL_PENDENCIA = {
  id: 1,
  nome: '',
  cnpj: '',
  tp_name: '',
  uf_id: 0,
  city_id: 0,
  telefone: '',
  actived: true,
  created_at: '',
  updated_at: '',
  porMovimentacao: [
    {
      movimentacao_id: 0,
      data_movimentacao: '',
      patrimonio_name: '',
      saldo: 0,
      patrimonio_id: 0,
    },
    {
      movimentacao_id: 0,
      data_movimentacao: '',
      patrimonio_name: '',
      saldo: 0,
      patrimonio_id: 0,
    },
  ],
  consolidado: [
    {
      patrimonio_name: '',
      saldo: 0,
    },
    {
      patrimonio_name: '',
      saldo: 0,
    },
  ],
}

const INITIAL_STATE = {
  pendencia: { ...INITIAL_PENDENCIA },
  activeIndex: 0,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useModalPendenciasTransportadora() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events
      onInit(pendencia) {
        setState(prevState => ({ ...prevState, pendencia: pendencia }))
      },

      onTabChange(value) {
        setState(prevState => ({ ...prevState, activeIndex: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
